<div class="popup-back-button-container">
  <dx-button i18n-text="@@back" class="popup-back-button" i18n-text text="BACK" icon="" [width]="200" [height]="44"
    (onClick)="goBack()">
  </dx-button>
</div>